import React from 'react'
import './styles/anchor.scss'
import { Link } from 'react-router-dom'

const Anchor = (props) => {
    const {
        children, cssClass, onClick, style, href, isExternal, target,
    } = props

    if (!href) {
        return (
            <div style={style} onClick={onClick} className={`anchor ${cssClass || ''}`}>
                {children}
            </div>
        )
    }
    if (isExternal) {
        return (
            <a style={style} href={href} onClick={onClick} target={target} className={`anchor ${cssClass || ''}`}>
                {children}
            </a>
        )
    }
    return (
        <Link style={style} to={href} onClick={onClick} className={`anchor ${cssClass || ''}`}>
            {children}
        </Link>
    )
}

export default Anchor
